import React, { createContext, useContext, useState, ReactNode } from 'react';
import { useSarLabAuth } from './SarLabAuthContext';

interface Message {
  id: string;
  text: string;
  userId: string;
  username: string;
  timestamp: number;
  type: 'text' | 'system';
  isAdmin?: boolean;
}

interface OnlineUser {
  userId: string;
  username: string;
  lastSeen: number;
  status: 'online' | 'away' | 'offline';
}

interface ChatContextType {
  messages: Message[];
  onlineUsers: OnlineUser[];
  isConnected: boolean;
  unreadCount: number;
  sendMessage: (text: string) => Promise<void>;
  deleteMessage: (messageId: string) => Promise<void>;
  setTyping: (isTyping: boolean) => void;
  typingUsers: string[];
  markAsRead: () => void;
}

const ChatContext = createContext<ChatContextType>({} as ChatContextType);

export const useChat = () => {
  return useContext(ChatContext);
};

interface ChatProviderProps {
  children: ReactNode;
}

export const ChatProvider: React.FC<ChatProviderProps> = ({ children }) => {
  const { currentPlayer } = useSarLabAuth();
  const [messages] = useState<Message[]>([]);
  const [onlineUsers] = useState<OnlineUser[]>([]);
  const [typingUsers] = useState<string[]>([]);
  const [unreadCount] = useState(0);

  // Mesaj gönder - SarLab API entegrasyonu için placeholder
  const sendMessage = async (text: string) => {
    if (!currentPlayer || !text.trim()) {
      return;
    }
    // TODO: SarLab chat API entegrasyonu
    console.log('Chat message (not implemented yet):', text);
  };

  // Yazıyor göstergesi - placeholder
  const setTyping = (_isTyping: boolean) => {
    // TODO: SarLab chat API entegrasyonu
  };

  // Mesaj silme - placeholder
  const deleteMessage = async (_messageId: string) => {
    // TODO: SarLab chat API entegrasyonu
  };

  // Mesajları okundu olarak işaretle
  const markAsRead = () => {
    // TODO: SarLab chat API entegrasyonu
  };

  const value = {
    messages,
    onlineUsers,
    isConnected: !!currentPlayer,
    unreadCount,
    sendMessage,
    deleteMessage,
    setTyping,
    typingUsers,
    markAsRead
  };

  return (
    <ChatContext.Provider value={value}>
      {children}
    </ChatContext.Provider>
  );
};
